import { Logger } from "../../infrastructure/Logger";

export class ApiDataAccess {
    constructor(baseUrl, settings = ApiDataAccess.settings) {
        if (!("fetch" in window)) {
            throw Error("Browser does not support fetch API");
        }

        this.props = {
            baseUrl: baseUrl,
            cacheName: "default-cache",
            settings: settings,
        };
    }

    static settings = {
        loader: true,
        mode: "cors", // no-cors, cors, *same-origin
        cache: "default", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "include", // include, same-origin, *omit
        redirect: "follow", // manual, *follow, error
        referrer: "no-referrer", // no-referrer, *client
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    };

    getAbsoluteUrl(url) {
        return this.props.baseUrl + url;
    }

    get(url, onSuccess, onError) {
        Logger.writeDebug("ApiDataAccess: get", { url: url });

        var settings = { ...this.props.settings };
        if (settings.loader == true) {
            //window.Loader.show();
        }

        settings.method = "GET";

        var uri = this.getAbsoluteUrl(url);
        Logger.writeInfo("ApiDataAccess.get - " + uri, settings);
        fetch(uri, settings)
            .then((response) => this.handleResponse(response))
            .then((response) => this.evaluateResponse(response, onSuccess, onError))
            .catch((response) => this.handleError(response, onError));
    }

    async getAsync(url) {
        Logger.writeDebug("ApiDataAccess: getAsync", { url: url });

        var settings = { ...this.props.settings };
        if (settings.loader == true) {
            //window.Loader.show();
        }

        settings.method = "GET";

        var uri = this.getAbsoluteUrl(url);
        Logger.writeInfo("ApiDataAccess.get - " + uri, settings);
        var response = await fetch(uri, settings);

        if (response.ok) {
            var json = await response.json();
            return json;
        } else {
            throw Error(response.statusText);
        }
    }

    post(url, data, onSuccess, onError) {
        Logger.writeDebug("ApiDataAccess: post", { url: url, data: data });

        var settings = { ...this.props.settings };
        if (settings.loader == true) {
            //window.Loader.show();
        }

        settings.method = "POST";
        settings.body = JSON.stringify(data);

        var uri = this.getAbsoluteUrl(url);
        Logger.writeInfo("ApiDataAccess.post - " + uri, settings);
        fetch(uri, settings)
            .then((response) => this.handleResponse(response))
            .then((response) => this.evaluateResponse(response, onSuccess, onError))
            .catch((response) => this.handleError(response, onError));
    }

    async postCallback(url, data) {
        Logger.writeDebug("ApiDataAccess: post", { url: url, data: data });

        var settings = { ...this.props.settings };
        if (settings.loader == true) {
            //window.Loader.show();
        }

        settings.method = "POST";
        settings.body = JSON.stringify(data);

        var uri = this.getAbsoluteUrl(url);
        Logger.writeInfo("ApiDataAccess.post - " + uri, settings);
        return await fetch(uri, settings);
    }

    put(url, data, onSuccess, onError) {
        Logger.writeDebug("ApiDataAccess: put", { url: url, data: data });

        var settings = { ...this.props.settings };
        if (settings.loader == true) {
            //window.Loader.show();
        }

        settings.method = "PUT";
        settings.body = JSON.stringify(data);
        var uri = this.getAbsoluteUrl(url);

        Logger.writeInfo("ApiDataAccess.put - " + uri, settings);
        fetch(uri, settings)
            .then((response) => this.handleResponse(response))
            .then((response) => this.evaluateResponse(response, onSuccess, onError))
            .catch((response) => this.handleError(response, onError));
    }

    async putCallback(url, data) {
        Logger.writeDebug("ApiDataAccess: putCallback", { url: url, data: data });

        var settings = { ...this.props.settings };
        if (settings.loader == true) {
            //window.Loader.show();
        }

        settings.method = "PUT";
        settings.body = JSON.stringify(data);
        var uri = this.getAbsoluteUrl(url);

        Logger.writeInfo("ApiDataAccess.put - " + uri, settings);
        return await fetch(uri, settings);
    }

    delete(url, onSuccess, onError) {
        Logger.writeDebug("ApiDataAccess: delete", { url: url });

        var settings = { ...this.props.settings };

        settings.method = "DELETE";

        var uri = this.getAbsoluteUrl(url);
        Logger.writeInfo("ApiDataAccess.delete - " + uri, settings);
        fetch(uri, settings)
            .then((response) => this.handleResponse(response))
            .then((response) => this.evaluateResponse(response, onSuccess, onError))
            .catch((response) => this.handleError(response, onError));
    }

    async deleteAsync(url) {
        Logger.writeDebug("ApiDataAccess: deleteAsync", { url: url});

        var settings = { ...this.props.settings };

        settings.method = "DELETE";

        var uri = this.getAbsoluteUrl(url);
        Logger.writeInfo("ApiDataAccess.deleteAsync - " + uri, settings);
        return await fetch(uri, settings);
    }

    async uploadAsync(url, data) {
        Logger.writeDebug("ApiDataAccess: uploadAsync", { url: url, data: data });
        var uri = this.getAbsoluteUrl(url);

        return await fetch(uri, {
            method: "POST",
            body: data,
        });
    }

    upload(url, data, onSuccess, onError) {
        //window.Loader.show();

        var uri = this.getAbsoluteUrl(url);
        fetch(uri, {
            method: "POST",
            body: data,
        })
            .then((response) => this.handleResponse(response))
            .then((response) => this.evaluateResponse(response, onSuccess, onError))
            .catch((response) => this.handleError(response, onError));
    }

    handleResponse(response) {
        //window.Loader.hide();

        if (response.status === 401 || response.status === 403) {
            //window.location = "/Account/SignOut";
        }
        Logger.writeDebug("ApiDataAccess.handleResponse - " + response.url, response.status);
        return response;
    }

    evaluateResponse(response, onSuccess, onError) {
        if (response.status === 204) {
            onSuccess({});
        }
        var promise = response.json();
        promise.then(function (json) {
            Logger.writeDebug("ApiDataAccess.handleJson - " + response.url, json);
            if (response.ok) {
                if (onSuccess) {
                    onSuccess(json);
                }
            } else {
                if (onError) {
                    onError(json);
                }
            }
        });
    }

    handleError(response, onError) {
        Logger.writeError("ApiDataAccess.handleError", response);
        throw Error(response.statusText);
    }
}
